import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSagawa({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.532l.924-.058c.02.15.06.264.122.343.1.127.243.19.429.19a.474.474 0 00.32-.097.292.292 0 00.113-.226.288.288 0 00-.107-.219c-.072-.064-.237-.125-.498-.182-.425-.096-.73-.223-.91-.382a.768.768 0 01-.275-.606c0-.162.047-.314.14-.458a.931.931 0 01.423-.339c.188-.082.445-.123.772-.123.402 0 .708.075.92.224.21.15.335.387.375.713l-.915.053c-.024-.141-.075-.244-.153-.308a.492.492 0 00-.323-.097c-.113 0-.198.024-.255.072a.22.22 0 00-.086.175c0 .05.024.095.07.135.047.041.155.08.327.116.424.091.728.184.912.277a.96.96 0 01.4.349.883.883 0 01.126.465.997.997 0 01-.167.557c-.111.17-.267.3-.467.387-.2.088-.453.132-.757.132-.535 0-.905-.103-1.11-.309a1.218 1.218 0 01-.35-.784zM7.1 10.375H5.897l-1.023 3.25h.865l.158-.632h1.155l.191.632h.928l-1.073-3.25zm-.892 2l.312-1.123.312 1.124h-.624z"
        fill="#3B499F"
      />
      <path
        d="M10.376 12.481h-.47v-.707h1.34v.089a1.653 1.653 0 010 .306v1.444h-.66v-.266a1.32 1.32 0 01-.795.278c-1.084-.012-1.666-.64-1.666-1.625 0-.983.702-1.596 1.666-1.624.774-.023 1.202.45 1.426 1.079h-.963c-.078-.268-.296-.334-.495-.334-.628 0-.73.424-.73.898 0 .474.134.93.73.93.393 0 .553-.198.617-.468z"
        fill="#3B499F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 10.375h-1.202l-1.023 3.25h.865l.158-.632h1.155l.191.632h.928l-1.073-3.25zm-.892 2l.312-1.123.312 1.124h-.624z"
        fill="#3B499F"
      />
      <path
        d="M14.375 10.375l.809 3.248h1.127L16.598 12l.371 1.624 1.14.002.766-3.25h-.959l-.367 1.973-.408-1.973h-1.036l-.343 1.973-.4-1.973h-.987z"
        fill="#3B499F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.912 10.375H19.71l-1.023 3.25h.864l.159-.632h1.154l.192.632h.928l-1.073-3.25zm-.892 2l.313-1.123.312 1.124h-.625z"
        fill="#3B499F"
      />
    </svg>
  )
}

export default SvgSagawa
